import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const checkBoxLabelCss = (isHideLanguageChecked) => ({
  alignItems: "flex-start",
  maxWidth: "calc(100vw - 32px)",
  width: "384px",
  padding: "0",
  color: isHideLanguageChecked ? ui.neutral[700] : ui.neutral[500],
  outlineOffset: "4px",
});
